import React from 'react';
import {Button, Card, DatePicker, Form, message, Spin} from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import {patchEventHeader} from "../../services/evt";
import moment from 'moment';

const RangePicker = DatePicker.RangePicker;

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewRegisterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false
        }
    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true)
                var _values = {...values};
                //处理活动报名起止时间
                if (_values.registerBeginTime && _values.registerEndTime) {
                    _values.registerBeginTime = _values.registerBeginTime.format("YYYY-MM-DD HH:mm:ss");
                    _values.registerEndTime = _values.registerEndTime.format("YYYY-MM-DD HH:mm:ss");
                } else {
                    _values.registerBeginTime = null;
                    _values.registerEndTime = null;
                }
                // delete _values.registerTime;

                patchEventHeader(Object.assign({id: this.props.evt.header.id}, _values)).then(res => {
                    console.log("updateEventConfig res: ", res);
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    render() {
        const evt = this.props.evt;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={this.intoEdit}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{padding: "16px"}}>
                        {editableTools}
                        <CkInfoItem
                            label={"活动报名起止时间"}
                        >
                            {
                                this.props.editable ?
                                    <div>
                                        {getFieldDecorator('registerBeginTime', {
                                            initialValue:evt.header.registerBeginTime ? moment(evt.header.registerBeginTime, 'YYYY-MM-DD HH:mm:ss') : null,
                                            rules: [
                                                {required: false, message: '报名时间为必填项'}
                                            ],
                                        })(
                                            <DatePicker
                                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                                placeholder="报名开始时间"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                style={{width: "170px"}}
                                            />
                                        )}
                                        ~
                                        {getFieldDecorator('registerEndTime', {
                                            initialValue:evt.header.registerEndTime ? moment(evt.header.registerEndTime, 'YYYY-MM-DD HH:mm:ss') : null,
                                            rules: [
                                                {required: false, message: '报名时间为必填项'}
                                            ],
                                        })(
                                            <DatePicker
                                                defaultPickerValue={moment('23:59:59', 'HH:mm:ss')}
                                                disabledDate={endValue=>{
                                                    const startValue = getFieldValue('registerBeginTime');
                                                    if (!endValue || !startValue) {
                                                        return false;
                                                    }
                                                    return endValue.valueOf() <= startValue.valueOf();
                                                }}
                                                showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }}
                                                placeholder="报名截止时间"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                style={{width: "170px"}}
                                            />
                                        )}
                                    </div>
                                    :
                                    evt.header.registerBeginTime ? (evt.header.registerBeginTime + " ~ " + evt.header.registerEndTime) : "未设置"
                            }
                        </CkInfoItem>
                    </Card>
                </Spin>
            </Form>
        )
    }
}


EvtViewRegisterForm.contextTypes = {}

EvtViewRegisterForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "registerEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewRegisterForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewRegisterForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewRegisterForm.jsx